import * as React from 'react';
import classnames from 'classnames';
import styles from './Separator.module.scss';

export const Separator = ({ className }: { className: string }) => (
  <div className={classnames(styles.separator, className)} />
);
